
const ApiCtl = {
  /** 查询用户信息及每个用户拥有的所有角色信息(可根据用户名(模糊)查询、所属组织id查询、用户状态查询、是否被删除查询)
   * /locationbs/sys/user/getAllUserAndAllRoleList
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param orgId {string} 组织ID
   * * * * @param username {string} 用户名
   * * * * * @param pageSize {number} 分页容量
   * * * * * * @param currentPage {number} 当前页码
   */
  getAllUserAndAllRoleList: function (_this, url, orgId, username, pageSize, currentPage) {
    _this.$axios({
      method: 'post',
      url: url,
      data: {
        uOrgId: orgId,
        username: username
      },
      params: {
        pageNum: currentPage,
        pageSize: pageSize
      },
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (resp) {
      if (resp.data.code === 200) {
        _this.userLoading = false
        _this.tableData = resp.data.data.pag
        _this.totalNum = resp.data.data.total
      } else {
        console.log(resp)
        _this.$message({
          message: resp.data.message,
          type: 'warning'
        })
      }
    }).catch(resp => {
      console.log('查询失败！' + resp)
    })
  },
  /** 新增用户、用户名和所属组织必填、其余信息不要填(前端注意)、默认登录密码：123456
   * /locationbs/sys/user/addUser
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param data {string} 添加用户表单数据
   */
  addUser: function (_this, url, data) {
    _this.$axios({
      method: 'post',
      url: url,
      data: data,
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (resp) {
      console.log(resp)
      if (resp.data.code === 200) {
        _this.$message({
          message: '操作成功',
          type: 'success'
        })
        _this.createAccountDialogFormVisible = false
        _this.$refs.creatFrom.resetFields()
        _this.$parent.getUserAccount()
      } else {
        _this.$message({
          message: resp.data.message,
          type: 'warning'
        })
      }
    }).catch(resp => {
      console.log('查询失败！' + resp)
    })
  },
  /** 根据id修改用户、用户id、用户名、组织id必填、管理员账户禁止修改、此接口禁止修改密码(前端注意)
   * /locationbs/sys/user/updateUser
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param data {Object} 修改用户表单数据
   */
  updateUser: function (_this, url, data) {
    _this.$axios({
      method: 'post',
      url: url,
      data: data,
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (resp) {
      if (resp.data.code === 200) {
        _this.$message({
          message: '保存成功',
          type: 'success'
        })
        _this.updateUserDialog = false
        _this.$parent.getUserAccount()
      } else {
        _this.$message({
          message: resp.data.message,
          type: 'warning'
        })
      }
    }).catch(resp => {
      console.log('保存失败！' + resp)
    })
  },
  /** 根据id删除单个或多个用户、用户id必填
   * /locationbs/sys/user/delUserById
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param data {[]} 删除用户ID数组
   */
  delUserById: function (_this, url, data) {
    _this.$axios({
      method: 'post',
      url: url,
      data: data,
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (resp) {
      if (resp.data.code === 200) {
        _this.$message({
          message: '删除成功',
          type: 'success'
        })
        _this.getUserAccount()
        _this.$refs.multipleTable.clearSelection()
        _this.delUIdList = []
      } else {
        _this.$message({
          message: resp.data.message,
          type: 'warning'
        })
      }
    }).catch(resp => {
      console.log('删除失败！' + resp)
    })
  },
  /** 查询角色信息(可根据角色名称(模糊)查询、角色编码(模糊)查询、角色状态查询、是否被删除查询)
   * /locationbs/sys/role/getAllRoleList
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param rName {string} 角色名
   * * * * @param pageSize {number} 分页容量
   * * * * * @param currentPage {number} 当前页码
   */
  getAllRoleList: function (_this, url, rName, pageSize, currentPage) {
    _this.$axios({
      method: 'post',
      url: url,
      data: {
        rName: rName
      },
      params: {
        pageNum: currentPage,
        pageSize: pageSize
      },
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (resp) {
      if (resp.data.code === 200) {
        _this.totalNum = resp.data.data.total
        _this.roleLoading = false
        _this.roleData = resp.data.data.pag
      } else {
        _this.$message({
          message: resp.data.message,
          type: 'warning'
        })
      }
    }).catch(resp => {
      console.log('查询失败！' + resp)
    })
  },
  /** 新增角色、角色名称和角色编码必填
   * /locationbs/sys/role/addRole
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param data {object} form表单数据
   */
  addRole: function (_this, url, data) {
    _this.$axios({
      method: 'post',
      url: url,
      data: data,
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (resp) {
      if (resp.data.code === 200) {
        if (typeof (resp.data.data) === 'number' && resp.data.data == 1) {
          _this.$message({
            message: resp.data.message,
            type: 'success'
          })

          _this.creatRoleDialogFormVisible = false
          _this.$refs.creatFrom.resetFields()
          _this.$parent.getRoleList()
        } else {
          _this.$message({
            message: resp.data.data.message,
            type: 'error'
          })
        }
      } else {
        _this.$message({
          message: resp.data.message,
          type: 'warning'
        })
      }
    }).catch(resp => {
      console.log('查询失败！' + resp)
    })
  },
  /** 根据id修改角色、角色id、角色名称、角色编码必填、超级管理员角色禁止修改
   * /locationbs/sys/role/updateRole
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param data {object} form表单数据
   */
  updateRole: function (_this, url, data) {
    _this.$axios({
      method: 'post',
      url: url,
      data: data,
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (resp) {
      if (resp.data.code === 200) {
        _this.$message({
          message: '保存成功',
          type: 'success'
        })
        _this.updateRoleDialogFormVisible = false
        _this.$parent.getRoleList()
      } else {
        _this.$message({
          message: resp.data.message,
          type: 'warning'
        })
      }
    }).catch(resp => {
      console.log('保存失败！' + resp)
    })
  },
  /** 根据id删除单个或多个角色、角色id必填
   * /locationbs/sys/role/delRoleById
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param data {[]} 角色ID数组
   */
  delRoleById: function (_this, url, data) {
    _this.$axios({
      method: 'post',
      url: url,
      data: data,
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (resp) {
      if (resp.data.code === 200) {
        _this.$message({
          message: '删除成功',
          type: 'success'
        })
        _this.getRoleList()
        _this.$refs.multipleTable.clearSelection()
      } else {
        _this.$message({
          message: resp.data.message,
          type: 'warning'
        })
      }
    }).catch(resp => {
      console.log('查询失败！' + resp)
    })
  },
  /** 编辑组织信息
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param data {string} form表单数据
   * * * * @param roleIds {string} 角色集合
   */
  updateOrganization: function (_this, url, data) {
    console.log(data)
    _this.$axios({
      method: 'post',
      url: url,
      data: {
        orgId: data.orgId,
        orgName: data.orgName,
        orgNo: data.orgNo,
        orgPid: data.orgPid,
        orgPids: data.orgPids
      },
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (res) {
      if (res.data.code === 200) {
        if (typeof (resp.data.data) === 'number' && res.data.data == 1) {
          _this.$message({
            message: res.data.message,
            type: 'success'
          })
          _this.updateOrgDialogFormVisible = false
          _this.$parent.refreshTree()
        } else {
          _this.$message({
            message: res.data.data.message,
            type: 'error'
          })
        }
      } else {
        _this.$message({
          message: res.data.message,
          type: 'warning'
        })
      }
    }).catch(resp => {
      console.log('查询失败！' + resp)
    })
  },
  /** 给用户分配角色、必须传用户id和角色id集合
   * /locationbs/sys/user/userToRole
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param uId {string} 用户ID
   * * * * @param rIdList {string} 角色集合
   */
  setRoleToAccount: function (_this, url, uId, rIdList) {
    _this.$axios({
      method: 'post',
      url: url,
      params: {
        uId: uId
      },
      data: rIdList,
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (resp) {
      if (resp.data.code === 200) {
        _this.$message({
          message: '分配角色成功',
          type: 'success'
        })
        _this.setRoleDialogVisible = false
        _this.$parent.getUserAccount()
      } else {
        console.log(resp)
        _this.$message({
          message: resp.data.message,
          type: 'warning'
        })
      }
    }).catch(resp => {
      console.log('分配失败！' + resp)
    })
  },
  /** 给角色分配权限、必须传角色id和权限id集合
   * /locationbs/sys/role/roleToPerm
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param rId {string} 角色ID
   * * * * @param PermIds {string} 权限ID集合
   */
  roleToPerm: function (_this, url, rId, PermIds) {
    _this.$axios({
      method: 'post',
      url: url,
      params: {
        rId: rId
      },
      data: PermIds,
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (resp) {
      if (resp.data.code === 200) {
        _this.$message({
          message: '分配权限成功',
          type: 'success'
        })
        _this.setPermDialogVisible = false
        _this.$parent.getRoleList()
      } else {
        console.log(resp)
        _this.$message({
          message: resp.data.message,
          type: 'warning'
        })
      }
    }).catch(resp => {
      console.log('分配失败！' + resp)
    })
  },
  /** 查询所有权限
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   */
  getAllPermTree: function (_this, url) {
    _this.$axios({
      method: 'post',
      url: url,
      data: {
      },
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (resp) {
      if (resp.data.code === 200) {
        _this.permData = resp.data.data
      } else {
        _this.$message({
          message: resp.data.message,
          type: 'warning'
        })
      }
    }).catch(resp => {
      console.log('查询失败！' + resp)
    })
  },
  /** 根据角色ID查询权限
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param rId {string} 角色ID
   */
  getAllPermTreeById: function (_this, url, rId) {
    _this.$axios({
      method: 'post',
      url: url,
      data: {
      },
      params: {
        rId: rId
      },
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (resp) {
      if (resp.data.code === 200) {
        let list = resp.data.data.permIds
        if (list) {
          for (let perm of list) {
            _this.$refs.permTree.setChecked(perm, true, false)
          }
        }
      } else {
        _this.$message({
          message: resp.data.message,
          type: 'warning'
        })
      }
    }).catch(resp => {
      console.log('查询失败！' + resp)
    })
  },
  /** 重置密码
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   */
  resetPass: function (_this, url, rId) {
    _this.$axios({
      method: 'get',
      url: url,
      params: {
        rId: rId
      },
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (resp) {
      if (resp.data.code === 200) {
      } else {
        _this.$message({
          message: resp.data.message,
          type: 'warning'
        })
      }
    }).catch(resp => {
      console.log('修改失败！' + resp)
    })
  },
  /** 根据菜单ID查询权限
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param pId {string} 菜单ID
   */
  getMenuByMenuId: function (_this, url, pId) {
    _this.$axios({
      method: 'post',
      url: url,
      data: {
      },
      params: {
        menuId: pId
      },
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (resp) {
      if (resp.data.code === 200) {
        _this.MenuPerData = resp.data.data
      } else {
        _this.$message({
          message: resp.data.message,
          type: 'warning'
        })
      }
    }).catch(resp => {
      console.log('getMenuByMenuId失败！' + resp)
    })
  },
  /** 根据组织ID查询详情
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param orgId {string} 组织ID
   */
  getOrgInfoById: function (_this, url, orgId) {
    _this.$axios({
      method: 'post',
      url: url,
      data: {
        orgId: orgId
      },
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (resp) {
      if (resp.data.code === 200) {
        _this.creatFrom = resp.data.data.pag[0]
      } else {
        _this.$message({
          message: resp.data.message,
          type: 'warning'
        })
      }
    }).catch(resp => {
      console.log('getMenuByMenuId失败！' + resp)
    })
  }
}
export default ApiCtl



// WEBPACK FOOTER //
// ./src/javascript/permApi.js